module.exports = __webpack_public_path__ + "img/Women_on_a_phone.7d43fa27.jpg";